<script lang="ts">
    import {onMount} from "svelte";
    import FontAwesomeView from "../../common/Image/FontAwesomeView.svelte";
    import {MouseEnterTipsViewUtil} from "../../common/Information/MouseEnterTipsViewUtil";
    import SpaceAuthorityDialogView from "./SpaceAuthorityDialogView.svelte";

    export let space;

    let isShowSpaceAuthorityCheckDialog = false;


    onMount(() => {
    });

    function onClickAuthorityInformation() {
        isShowSpaceAuthorityCheckDialog = true;
    }

    function onCloseSpaceAuthorityCheckDialog() {
        isShowSpaceAuthorityCheckDialog = false;
    }


</script>

<div class="space-authority-view" on:click={onClickAuthorityInformation}
     on:mouseenter={(event)=>{MouseEnterTipsViewUtil.show(event, "スペースが誰に公開されているか確認できます");}}
>
    <FontAwesomeView icon="lock"/>

    <SpaceAuthorityDialogView spaceId={space.id} isShow={isShowSpaceAuthorityCheckDialog}
                              on:close={onCloseSpaceAuthorityCheckDialog}
    />

</div>


<style lang="scss">
    .space-authority-view {
        cursor: pointer;

    }
</style>